module.exports = __webpack_public_path__ + "img/SIPSD.3e4769ed.svg";